<template><div></div></template>
<script>
export default {
    name: "account-two-factor-redirect",
    created() {
        this.$router.replace({ path: "/account", query: { action: "enable-2fa" } });
    },
};
</script>
